import {Plot} from "./plot";
import {StepIndicator} from "./stepIndicator";
import {Summary} from "./summary";

export default class Configurator {

	activeStep: number;
	selectedProject: number | null;
	selectedPlot: number | null;
	private wrapper: HTMLDivElement;
	private stepIndicator: StepIndicator;
	private step1: HTMLDivElement;
	private step2: HTMLDivElement;
	private step3: HTMLDivElement;
	private step4: HTMLDivElement;
	private nextBtn: HTMLButtonElement;

	private summary: Summary = new Summary;
	private imagePopup: HTMLDialogElement;
	private popupImage: HTMLImageElement;
	private contactPopup: HTMLDialogElement;

	constructor(wrapper: HTMLDivElement) {
		this.wrapper = wrapper;

		this.stepIndicator = new StepIndicator(wrapper, parseInt(wrapper.dataset.steps));
		this.activeStep = parseInt(wrapper.dataset.step);
		this.selectedProject = wrapper.dataset.selectedProject ? parseInt(wrapper.dataset.selectedProject) : null;
		this.selectedPlot = wrapper.dataset.selectedPlot ? parseInt(wrapper.dataset.selectedPlot) : null;

		this.step1 = this.wrapper.querySelector('#configurator-step-1');
		this.step2 = this.wrapper.querySelector('#configurator-step-2');
		this.step3 = this.wrapper.querySelector('#configurator-step-3');
		this.step4 = this.wrapper.querySelector('#configurator-step-4');
		this.nextBtn = this.wrapper.querySelector('.configurator-actions .next');

		this.imagePopup = document.getElementById('configurator-image-popup') as HTMLDialogElement;
		this.popupImage = this.imagePopup.querySelector('img');
		this.contactPopup = document.getElementById('configurator-contact-popup') as HTMLDialogElement;
	}

	init() {
		// Close dialog on clicking on the close button
		this.imagePopup.querySelector('.close-btn').addEventListener('click', () => {
			this.imagePopup.close();
		});
		this.contactPopup.querySelector('.close-btn').addEventListener('click', () => {
			this.contactPopup.close();
		});
		// Close dialog on clicking on backdrop
		this.imagePopup.addEventListener('click', e => {
			const rect = this.imagePopup.getBoundingClientRect();
			const isInDialog = (rect.top <= e.clientY && e.clientY <= rect.top + rect.height && rect.left <= e.clientX && e.clientX <= rect.left + rect.width);
			if (!isInDialog) {
				this.imagePopup.close();
			}
		});
		this.contactPopup.addEventListener('click', e => {
			const rect = this.contactPopup.getBoundingClientRect();
			const isInDialog = (rect.top <= e.clientY && e.clientY <= rect.top + rect.height && rect.left <= e.clientX && e.clientX <= rect.left + rect.width);
			if (!isInDialog) {
				this.contactPopup.close();
			}
		});
		const contactForm = this.contactPopup.querySelector('form');
		if (contactForm) {
			this.initContactForm(contactForm);
		}

		this.stepIndicator.setStep(this.activeStep);
		switch (this.activeStep) {
			case 1:
				this.initStep1();
				break;
			case 2:
				this.initStep2();
				break;
			case 3:
				this.initStep3();
				break;
			case 4:
				this.initStep4();
				break;
		}

		(document.querySelectorAll('.backBtn') as NodeListOf<HTMLButtonElement>).forEach(btn => {
			btn.addEventListener('click', () => {
				switch (this.activeStep) {
					case 2:
						this.activeStep = 1;
						this.loadStep1().then(() => {
							this.initStep1();
							this.summary.clearPrices();
							this.stepIndicator.setStep(this.activeStep);
							this.updateHistory();
						});
						break;
					case 3:
						this.activeStep = 2;
						this.loadStep2().then(() => {
							this.initStep2();
							this.summary.clearPrices();
							this.stepIndicator.setStep(this.activeStep);
							this.updateHistory();
						});
						break;
					case 4:
						this.activeStep = 3;
						this.loadStep3().then(() => {
							this.initStep3();
						});
						this.stepIndicator.setStep(this.activeStep);
						this.updateHistory();
						break;
				}
			});
		})

		this.nextBtn.addEventListener('click', () => {
			if (this.activeStep !== 3) {
				return;
			}

			if (!this.validateStep3()) {
				this.step3.querySelector('.equipment-mandatory .error-message').classList.add('show');
				this.wrapper.scrollIntoView({
					behavior: 'smooth', block: 'start'
				});
				return;
			} else {
				this.step3.querySelector('.equipment-mandatory .error-message').classList.remove('show');
			}

			this.activeStep = 4;
			this.loadStep4().then(() => {
				this.initStep4();
			});
			this.stepIndicator.setStep(this.activeStep);
			this.updateHistory();
		});

		console.log(this);
	}

	selectProject(id: number) {
		this.selectedProject = id;
		this.wrapper.setAttribute('data-selected-project', id.toString());
		this.activeStep = 2;
	}

	selectPlot(id: number) {
		this.selectedPlot = id;
		this.wrapper.setAttribute('data-selected-plot', id.toString());
		this.activeStep = 3;
	}

	initStep1() {
		this.initCarousel();
		console.log('Init step 1');

		this.selectedPlot = null;

		(this.wrapper.querySelectorAll('.project-select') as NodeListOf<HTMLButtonElement>).forEach(btn => {
			btn.addEventListener('click', () => {
				this.selectProject(parseInt(btn.dataset.id));
				this.loadStep2().then(() => {
					this.initStep2();
					this.summary.refresh(this.selectedProject);
				});
				this.stepIndicator.setStep(this.activeStep);
				this.updateHistory();
			});
		});

		(this.wrapper.querySelectorAll('.contact-realter') as NodeListOf<HTMLButtonElement>).forEach(btn => {
			btn.addEventListener('click', () => {
				this.contactPopup.showModal();
			});
		});

		this.step1.querySelectorAll('.discount-banner').forEach(banner => {
			banner.addEventListener('click', () => {
				this.showDiscountPopup();
			})
		});
		this.initMap();
	}

	private initMap() {
		const mapWrapper = this.step1.querySelector<HTMLDivElement>('.projects-map');
		if (!mapWrapper) {
			return;
		}
	}

	async loadStep1() {
		// Start loader
		const loader = this.createLoader();
		this.step1.appendChild(loader);

		const params: {
			[index: string]: number | string
		} = Object.fromEntries(new URLSearchParams(window.location.search));
		params.project = this.selectedProject;
		const response = await this.loadStep(1, params);
		if (response.ok) {
			this.step1.querySelector('.step-content').innerHTML = await response.text();
		} else {
			// TODO: Handle error
		}

		// Stop loading
		loader.remove();
	}

	async loadStep2() {
		// Start loader
		const loader = this.createLoader();
		this.step2.appendChild(loader);


		const params: {
			[index: string]: number | string
		} = Object.fromEntries(new URLSearchParams(window.location.search));
		params.project = this.selectedProject;
		params.plot = this.selectedPlot;
		const response = await this.loadStep(2, params);
		if (response.ok) {
			this.step2.querySelector('.step-content').innerHTML = await response.text();
			this.summary.update();
		} else {
			// TODO: Handle error
		}

		// Stop loading
		loader.remove();
	}

	async loadStep3() {
		// Start loader
		const loader = this.createLoader();
		this.step3.appendChild(loader);

		const params: {
			[index: string]: number | string
		} = Object.fromEntries(new URLSearchParams(window.location.search));
		params.project = this.selectedProject;
		params.plot = this.selectedPlot;
		const response = await this.loadStep(3, params);
		if (response.ok) {
			this.step3.querySelector('.step-content').innerHTML = await response.text();
			this.summary.update();
		} else {
			// TODO: Handle error
		}

		// Stop loading
		loader.remove();
	}

	async loadStep4() {
		// Start loader
		const loader = this.createLoader();
		this.step4.appendChild(loader);

		const params = this.summary.getHistoryParamsObject();
		params.project = this.selectedProject;
		params.plot = this.selectedPlot;
		const response = await this.loadStep(4, params);
		if (response.ok) {
			this.step4.querySelector('.step-content').innerHTML = await response.text();
			this.summary.update();
		} else {
			// TODO: Handle error
		}

		// Stop loading
		loader.remove();
	}

	initStep2() {
		this.initCarousel();

		const title = this.step2.querySelector('.configurator-step-title') as HTMLHeadingElement;
		const equipmentWrapper = this.step2.querySelector('.plots') as HTMLDivElement;
		title.innerText = title.dataset.base;
		if (equipmentWrapper && equipmentWrapper.dataset.projectName) {
			title.innerText += ' - ' + equipmentWrapper.dataset.projectName;
		}

		const svg = this.step2.querySelector('svg.plot-select-overlay') as SVGSVGElement;
		const plots = this.step2.querySelectorAll('.plot-polygon') as NodeListOf<SVGPathElement>;
		const projectInfoWrapper = this.step2.querySelector('.project-info-wrapper') as HTMLDivElement;
		const projectInfo = projectInfoWrapper.querySelector('.project-info') as HTMLDivElement;
		const projectInfoTaken = projectInfoWrapper.querySelector('.project-taken-info') as HTMLDivElement;
		const projectImage = this.step2.querySelector('.project-image img') as HTMLImageElement;
		const projectExcerpt = this.step2.querySelector('.project-excerpt p') as HTMLParagraphElement;
		const plotTables = this.step2.querySelector('.tables') as HTMLDivElement;
		const projectMinPrice = this.step2.querySelector('.project-excerpt .min-price') as HTMLSpanElement;
		const projectMinPriceLabel = this.step2.querySelector('.project-excerpt strong') as HTMLSpanElement;
		const selectBtn = this.step2.querySelector('#select-plot') as HTMLButtonElement;
		const tooltips = this.step2.querySelector('.tooltips') as HTMLDivElement;

		const takenMessage = this.step2.querySelector('#taken-message') as HTMLDivElement;
		const prebuiltMessage = this.step2.querySelector('#prebuilt-message') as HTMLDivElement;
		const onlyplotMessage = this.step2.querySelector('#onlyplot-message') as HTMLDivElement;

		let selectedId: number = 0;

		let selectedPlotName = '';
		let selectedPlotImage = '';

		plots.forEach(plot => {
			const plotPrice = parseFloat(plot.dataset.plotPrice ?? '0.0');
			const basePrice = parseFloat(plot.dataset.basePrice ?? '0.0');
			const minPrice = parseFloat(plot.dataset.minPrice ?? '0.0');

			const plotObj = new Plot(plot, svg, projectInfoWrapper, projectImage, projectExcerpt, plotTables, tooltips);
			plotObj.init();

			if (plot.classList.contains('selected')) {
				selectedId = plotObj.select();
				this.summary.basePrice = basePrice;
				this.summary.plotPrice = plotPrice;
				projectMinPrice.innerText = minPrice.toLocaleString(undefined, {
					style: 'currency', currency: 'CZK', maximumFractionDigits: 0
				});
				if (plotObj.taken) {
					takenMessage.style.display = 'block';
					prebuiltMessage.style.display = 'none';
					selectBtn.style.display = 'none';
					onlyplotMessage.style.display = 'none';
				} else if (plotObj.prebuilt) {
					takenMessage.style.display = 'none';
					prebuiltMessage.style.display = 'block';
					selectBtn.style.display = 'none';
					onlyplotMessage.style.display = 'none';
				} else if (plotObj.onlyplot) {
					takenMessage.style.display = 'none';
					prebuiltMessage.style.display = 'none';
					selectBtn.style.display = 'none';
					onlyplotMessage.style.display = 'block';
				} else {
					takenMessage.style.display = 'none';
					prebuiltMessage.style.display = 'none';
					selectBtn.style.display = 'inline-block';
					onlyplotMessage.style.display = 'none';
				}

				selectedPlotName = plotObj.name;
				selectedPlotImage = plotObj.imageUrlFull;
			}

			const selectPlot = () => {
				if (plotObj.taken) {
					plotObj.select();
					projectInfo.style.display = 'none';
					projectInfoTaken.style.display = 'block';
					return;
				}
				projectInfo.style.display = 'grid';
				projectInfoTaken.style.display = 'none';
				selectedId = plotObj.select();
				this.summary.basePrice = basePrice;
				this.summary.plotPrice = plotPrice;
				this.summary.clearPrices().update();
				if (plotObj.prebuilt) {
					projectMinPriceLabel.innerText = 'Cena domu:';
				}
				else if (plotObj.onlyplot) {
					projectMinPriceLabel.innerText = 'Cena pozemku:';
				}
				else {
					projectMinPriceLabel.innerText = 'Cena domu od:';
				}
				projectMinPrice.innerText = minPrice.toLocaleString(undefined, {
					style: 'currency', currency: 'CZK', maximumFractionDigits: 0
				});
				if (plotObj.taken) {
					takenMessage.style.display = 'block';
					prebuiltMessage.style.display = 'none';
					selectBtn.style.display = 'none';
					onlyplotMessage.style.display = 'none';
				} else if (plotObj.prebuilt) {
					takenMessage.style.display = 'none';
					prebuiltMessage.style.display = 'block';
					selectBtn.style.display = 'none';
					onlyplotMessage.style.display = 'none';
				} else if (plotObj.onlyplot) {
					takenMessage.style.display = 'none';
					prebuiltMessage.style.display = 'none';
					selectBtn.style.display = 'none';
					onlyplotMessage.style.display = 'block';
				} else {
					takenMessage.style.display = 'none';
					prebuiltMessage.style.display = 'none';
					selectBtn.style.display = 'inline-block';
					onlyplotMessage.style.display = 'none';
				}

				selectedPlotName = plotObj.name;
				selectedPlotImage = plotObj.imageUrlFull;
			};

			plot.addEventListener('click', selectPlot);
			plot.addEventListener('touchstart', selectPlot);
		});

		selectBtn.addEventListener('click', () => {
			if (selectedId < 1 || selectBtn.style.display === 'none') {
				return;
			}

			this.selectPlot(selectedId);
			this.loadStep3().then(() => {
				this.initStep3();
				this.summary.refresh(this.selectedProject, this.selectedPlot);
			});
			this.stepIndicator.setStep(this.activeStep);
			this.updateHistory();
		});

		projectImage.addEventListener('click', () => {
			this.showImagePopup(selectedPlotImage, selectedPlotName);
		});

		this.step2.querySelectorAll('.discount-banner').forEach(banner => {
			banner.addEventListener('click', () => {
				this.showDiscountPopup();
			})
		});
	}

	initStep3() {
		this.initCarousel();

		const seenHelp = window.localStorage.getItem('seenHelp');
		console.log(seenHelp, Date.now());
		if (!seenHelp || (seenHelp.length > 0 && parseInt(seenHelp) < Date.now())) {
			this.showHelpPopup();
			window.localStorage.setItem('seenHelp', (Date.now() + (3_600_000 * 24)).toString());
		}

		const title = this.step3.querySelector('.configurator-step-title') as HTMLHeadingElement;
		const equipmentWrapper = this.step3.querySelector('.equipment') as HTMLDivElement;
		title.innerText = title.dataset.base;
		if (equipmentWrapper && equipmentWrapper.dataset.plotName) {
			title.innerText += ' - ' + equipmentWrapper.dataset.plotName;
		}

		const params = new URLSearchParams(equipmentWrapper.dataset.equipment ?? window.location.search);
		const whiteWallAll = this.step3.querySelector('.whitewallAll') as HTMLButtonElement;

		const whiteWallSelects: ((updateState: boolean) => void)[] = [];

		const errorMessage = this.step3.querySelector('.equipment-mandatory .error-message');

		const rekuperace = this.step3.querySelector(`.equipment-category[data-name="Rekuperace"]`) as HTMLDivElement;
		const termostat = this.step3.querySelector(`.equipment-category[data-name="Pokojový termostat"]`) as HTMLDivElement;
		rekuperace.addEventListener('configurator-select', (e: CustomEvent<{ name: string, price: number }>) => {
			console.log(e.detail);
			if (e.detail.name !== 'whitewall') {
				termostat.style.display = 'none';
			} else {
				termostat.style.display = 'block';
			}
		});
		termostat.addEventListener('configurator-select', (e: CustomEvent<{ name: string, price: number }>) => {
			console.log(e.detail);
			if (e.detail.name !== 'whitewall') {
				rekuperace.style.display = 'none';
			} else {
				rekuperace.style.display = 'block';
			}
		});

		const stepContent = this.step3.querySelector('.step-content') as HTMLDivElement;
		let currMaxHeight = parseInt(window.getComputedStyle(this.step3).maxHeight.replace('px', ''));
		const maxHeightPadding = 1000;
		const updateBoxMaxHeight = () => {
			const height = stepContent.getBoundingClientRect().height;
			if ((currMaxHeight - maxHeightPadding) < height) {
				currMaxHeight = height + 1000;
				this.step3.style.maxHeight = `${currMaxHeight}px`;
			}
		};
		const resizeObserver = new ResizeObserver(updateBoxMaxHeight);
		resizeObserver.observe(stepContent);

		const categories = this.step3.querySelectorAll('.equipment-category') as NodeListOf<HTMLDivElement>;
		categories.forEach((category, key) => {
			const id = parseInt(category.dataset.id);
			const categoryName = category.dataset.name;
			const optionBtns = category.querySelectorAll('.selectOption') as NodeListOf<HTMLButtonElement>;
			const header = category.querySelector('.category-header') as HTMLDivElement;
			const variantWrapper = header.querySelector('.selected-variant') as HTMLDivElement;
			const optionPriceDiffs = category.querySelectorAll<HTMLDivElement>('.option-footer .price-diff');

			let selectedOption: string;
			let selectedPrice: number;

			header.addEventListener('click', () => {
				category.classList.toggle('show');
			});

			optionBtns.forEach(btn => {
				const price = parseFloat(btn.dataset.price);
				const name = btn.dataset.name;

				const select = (updateState: boolean = true, first : boolean = false) => {
					selectedOption = name;
					selectedPrice = price;
					const selectedBtn = category.querySelector('.selectOption.selected');
					if (selectedBtn && selectedBtn !== btn && !first) {
						console.log(selectedBtn, btn);
						selectedBtn.classList.remove('selected');
					}

					this.summary.setPrice(id, selectedPrice).update();

					if (updateState) {
						window.history.replaceState({}, '', new URL(this.getUrl()));
					}

					if (!first) {
						btn.classList.add('selected');
						category.classList.remove('show');
					}
					category.classList.add('selected');
					category.classList.remove('error');
					variantWrapper.innerText = selectedOption;

					if (errorMessage.classList.contains('show') && this.validateStep3()) {
						errorMessage.classList.remove('show');
					}
					category.dispatchEvent(new CustomEvent('configurator-select', {detail: {name, price}}));

					optionPriceDiffs.forEach((option) => {
						const diff = parseInt(option.dataset.price) - selectedPrice;
						if (diff === 0) {
							option.innerText = '';
						}
						else {
							option.innerText = (diff > 0 ? '+':'') + diff.toLocaleString(undefined, {style: 'currency', currency: 'CZK', maximumFractionDigits: 0});
						}
					})

					if (updateState) {
						setTimeout(() => {
							if (categories[key + 1]) {
								if (categories[key + 1].style.display !== 'none') {
									categories[key + 1].classList.add('show');
								} else if (categories[key + 2]) {
									categories[key + 2].classList.add('show');
								}
							}
						}, 200);
					}
				}

				if (price === 0.0) {
					whiteWallSelects.push(select);
				}

				if (btn.classList.contains('selected') || (params.has(`e${id}`) && price === parseFloat(params.get(`e${id}`)))) {
					select(false, true);
				}

				btn.addEventListener('click', () => {
					select();
				});
			});
		});

		if (whiteWallAll) {
			whiteWallAll.addEventListener('click', () => {
				for (const fn of whiteWallSelects) {
					fn(false);
				}
				window.history.replaceState({}, '', new URL(this.getUrl()));
			});
		}

		const summary = this.step3.querySelector('.configurator-summary') as HTMLDivElement;
		let margin: number = 0;
		const offset = 20;
		window.addEventListener('scroll', () => {
			const max = (summary.parentElement.getBoundingClientRect().height - summary.getBoundingClientRect().height)
			margin -= summary.getBoundingClientRect().y - offset;
			if (margin < 0) {
				margin = 0;
			}
			if (margin > max) {
				margin = max;
			}
			summary.style.marginTop = `${margin}px`;
		});
	}

	private initContactForm(form: HTMLFormElement) {
		const messages = form.querySelector('.messages') as HTMLDivElement;
		form.addEventListener('submit', async (e) => {
			e.preventDefault();

			const body = new URLSearchParams();
			body.append('nonce', esoul_konfigurator_params.nonce);
			body.append('mobile', '1');
			(new FormData(form)).forEach((value, name) => {
				body.append(name, value.toString());
			});

			const response = await fetch(esoul_konfigurator_params.ajaxUrl, {
				method: 'post',
				headers: {
					"Content-Type": "application/x-www-form-urlencoded",
				},
				body,
			});
			const data: { status: 'error' | 'ok', error?: string, [index: string]: any } = await response.json();

			if (response.ok && data.status === 'ok') {
				const message = document.createElement('div');
				message.classList.add('notice', 'notice-success');
				message.innerText = form.dataset.success;
				messages.innerHTML = '';
				messages.appendChild(message);
			} else {
				const message = document.createElement('div');
				message.classList.add('notice', 'notice-error');
				message.innerText = form.dataset.error;
				messages.innerHTML = '';
				messages.appendChild(message);
			}
		});
	}

	initStep4(): void {
		this.initCarousel();
		const form = document.getElementById('konfigurator-contact-form') as HTMLFormElement;
		this.initContactForm(form);

		const shareBtns = this.step4.querySelectorAll('.share-pdf') as NodeListOf<HTMLButtonElement>;
		shareBtns.forEach(btn => {
			if (!navigator.canShare && !navigator.clipboard) {
				btn.style.display = 'none';
			}
			const shareData = {
				title: 'OneTwoTree', text: btn.dataset.description, url: btn.dataset.href,
			};
			btn.addEventListener('click', () => {
				if (navigator.canShare) {
					navigator.share(shareData);
				} else if (navigator.clipboard) {
					navigator.clipboard.writeText(shareData.url)
						.then(r => {
							alert('Zkopírováno do schránky');
						});
				}
			});
		});

		(document.querySelectorAll('.popup-image') as NodeListOf<HTMLImageElement>).forEach(image => {
			const url = image.dataset.src;
			image.addEventListener('click', () => {
				this.showImagePopup(url, image.alt);
			});
		});
	}

	private showImagePopup(url: string, alt: string = '') {
		this.popupImage.src = url;
		this.popupImage.alt = alt;

		this.imagePopup.showModal();
	}

	private showDiscountPopup() {
		// @ts-ignore
		window.elementorProFrontend.modules.popup.showPopup({id: 1297});
	}

	private showHelpPopup() {
		// @ts-ignore
		window.elementorProFrontend.modules.popup.showPopup({id: 982});
	}

	private validateStep3(): boolean {
		let valid = true;
		const categories = this.step3.querySelectorAll('.equipment-mandatory .equipment-category') as NodeListOf<HTMLDivElement>;
		for (const category of categories) {
			if (!category.classList.contains('selected')) {
				valid = false;
				category.classList.add('error');
			}
		}
		return valid;
	}

	private createLoader(): HTMLElement {
		const loader = document.createElement('div');
		loader.classList.add('loader-wrapper');
		loader.innerHTML = '<svg viewBox="0 0 100 100"><defs><circle id="loader" r="6" cx="50" cy="50" transform="translate(0 -30)"/></defs><g class="loader" transform="rotate(51 50 50)"><use xlink:href="#loader" /></g><g class="loader" transform="rotate(103 50 50)"><use xlink:href="#loader" /></g><g class="loader" transform="rotate(154 50 50)"><use xlink:href="#loader" /></g><g class="loader" transform="rotate(206 50 50)"><use xlink:href="#loader" /></g><g class="loader" transform="rotate(257 50 50)"><use xlink:href="#loader" /></g><g class="loader" transform="rotate(309 50 50)"><use xlink:href="#loader" /></g><g class="loader" transform="rotate(360 50 50)"><use xlink:href="#loader" /></g></svg>';
		return loader;
	}

	private async loadStep(step: number, params: { [index: string]: any } = {}) {
		params.action = 'konfigurator_step';
		params.step = step;
		params.nonce = esoul_konfigurator_params.nonce;
		params.mobile = 1;

		const searchParams = new URLSearchParams;
		this.jsonToSearchParams(searchParams, params);
		return fetch(esoul_konfigurator_params.ajaxUrl, {
			method: 'POST', headers: {"Content-Type": "application/x-www-form-urlencoded"}, body: searchParams,
		});
	}

	private jsonToSearchParams(params: URLSearchParams, data: { [index: string]: any }, currKey: string = ''): void {
		for (const key in data) {
			const combinedKey = currKey === '' ? key : currKey + `[${key}]`;

			if (typeof data[key] === 'object') {
				this.jsonToSearchParams(params, data[key], combinedKey);
				continue;
			}

			params.append(combinedKey, data[key]);
		}
	}

	private getUrl(): string {
		let url = window.location.origin + window.location.pathname + `?step=${this.activeStep}`;
		if (this.selectedProject > 0) {
			url += `&project=${this.selectedProject}`;
		}
		if (this.selectedPlot > 0) {
			url += `&plot=${this.selectedPlot}`;
		}
		url += this.summary.getHistoryParams();
		console.log(url);
		return url;
	}

	private updateHistory(): void {
		const url = this.getUrl();
		window.history.pushState({}, '', new URL(url));
	}

	private initCarousel(): void {
		const carousels = this.wrapper.querySelectorAll('.carousel-wrapper:not(.initialized)') as NodeListOf<HTMLDivElement>;

		carousels.forEach(wrapper => {
			wrapper.classList.add('initialized');

			const next = wrapper.querySelector('.next') as HTMLButtonElement;
			const prev = wrapper.querySelector('.prev') as HTMLButtonElement;
			const carousel = wrapper.querySelector('.carousel') as HTMLDivElement;

			console.log(carousel, carousel.scrollWidth, wrapper.clientWidth, carousel.getBoundingClientRect());

			const images = carousel.querySelectorAll('img');

			const getActiveImageIndex = () => {
				const scroll = carousel.scrollLeft;
				let left = 0;
				let i = 0;
				for (const image of images) {
					if (scroll >= left && scroll <= left + image.clientWidth) {
						return i;
					}
					left += image.clientWidth;
					i++;
				}
				return 0;
			}

			next.addEventListener('click', () => {
				if ((carousel.scrollLeft + (wrapper.clientWidth / 2)) > carousel.scrollWidth) {
					carousel.scrollLeft = 0;
				} else {
					carousel.scrollBy({left: wrapper.clientWidth});
				}
			});
			prev.addEventListener('click', () => {
				if ((carousel.scrollLeft - (wrapper.clientWidth / 2)) < 0) {
					carousel.scrollLeft = carousel.scrollWidth;
				} else {
					carousel.scrollBy({left: -wrapper.clientWidth});
				}
			});

			/**
			next.addEventListener('click', () => {
				const index = getActiveImageIndex();
				if (index >= (images.length - 1)) {
					images[0].scrollIntoView({behavior: "smooth", inline: 'center'});
				}
				else {
					images[index+1].scrollIntoView({behavior: "smooth", inline: 'center'});
				}
			});
			prev.addEventListener('click', () => {
				const index = getActiveImageIndex();
				if (index <= 0) {
					images[images.length - 1].scrollIntoView({behavior: "smooth", inline: 'center'});
				}
				else {
					images[index-1].scrollIntoView({behavior: "smooth", inline: 'center'});
				}
			});*/
		})
	}
}
